<template>
    <div class="resetPassword">
         <div class="login-wrap">
            <div class="container">

                <div class="col-md-6 col-sm-12 col-xs-12 login-inner">
                    <div class="containing-table">
                        <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left">
  <!--                        <img src="static/assets/images/logo.png">-->
                       <span class="o-rest-icon"><i class="fa fa-unlock-alt" aria-hidden="true"></i></span>
                        </div>
                        <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right">

                                <div class="login-screen">
                                  <form>
                                          <div class="form-group">
                                              <div class="clearfix">
                                                  <div class="form-group-left o-login-field">
                                                      <label>
                                                          <!-- Type New Password: -->
                                                          {{ $t('type_new_password') }}:</label>
                                                  </div>
                                                  <div class="form-group-right o-login-field">
                                                      <input type="password" class="form-control u-transparent" :placeholder="$t('enter_new_password')" v-model="password" id="passward" v-validate="'required|min:6'" name="password">
                                                      <span class="err-msg">
                                                          <!-- Passwords must be a minimum of 6 characters. -->
                                                          {{ $t('err_password_minimum') }}
                                                      </span>
                                                      <!-- <span v-show="errors.has('password') && this.validation_err!=0" class="err-msg">{{ errors.first('password') }}</span> -->
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="form-group">
                                              <div class="clearfix">
                                                  <div class="form-group-left o-login-field">
                                                      <!-- <label>Re-type new password:</label> -->
                                                      <label>{{ $t('retype_your_password') }}:</label>
                                                  </div>
                                                  <div class="form-group-right o-login-field">
                                                      <input type="password" class="form-control u-transparent" :placeholder="$t('confirm_new_password')" v-model="Repassword" id="pwd" v-validate="'required'" name="Repassword">
                                                      <span class="err-msg">
                                                          <!-- Password and confirm password should be same. -->
                                                          {{ $t('err_confirm_password_same') }}
                                                      </span>
                                                      <!-- <span v-show="errors.has('Repassword') && this.validation_err!=0" class="err-msg">{{ errors.first('Repassword') }}</span> -->
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="form-group">
                                              <div class="clearfix">
                                                  <a href="javascript: void(0)" @click="resetPasswordLink" class="c-solid-btn c-solid-btn--green o-login-btn">
                                                      <!-- Confirm -->
                                                      {{ $t('confirm') }}
                                                  </a>
                                              </div>
                                          </div>
                                          <div class="o-error-msg">
                                              <span class="cred_err"></span>
                                          </div>
                                      </form>
                                </div>


                        </div>
                    </div>

                     <p class="ps2 text-center u-margin-30">
                         <!-- After logging in for the first time, please change your password, and user name if desired. Verify all personal information, and assign your skills. -->
                         {{ $t('login_page_change_password_note') }}
                         </p>

                    <a href="javascript: void(0)" class="ps2 text-center display-block">
                        <!-- Privacy policy -->
                        {{ $t('privacy_policy') }}
                    </a>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </div>

      </div>
  </template>
  <style scoped>
    .wrapper {
        margin-left: 0px !important;
    }

  </style>
  <script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',

            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");

                  return("desktop" != check ? !0 : !1);

            }
        },
        data() {
            return {
                password: "",
                Repassword: "",
                validation_err: 0,
                employeeId: '',
            }
        },
        watch: {

        },
        methods: {

          resetPasswordLink() {
            this.$Progress.start();
            this.$validator.validateAll().then((result) => {
                if (result && this.password === this.Repassword) {
                    this.validation_err = 0;
                    service.post('auth/resetPassword', {
                          'password': this.password,
                          'token': this.employeeId
                      }, {})
                      .then((res) => {
                          this.$notify({
                              title: this.$t('success'),
                              message: this.$t('pass_reset_success'),
                              type: 'success'
                          });
                          this.$router.push({
                              path: `/login`
                          });
                      }).catch((err) => {
                          console.log(err);
                      });

                } else {
                    this.validation_err = 1;
                }
            });
          }
        },
        mounted() {
            //alert('created');
            // $('.loginVue').parent('.wrapper').css('margin-left', '0');
            // if(this.deviceDetector) {
            //     let firstPath = window.location.href.split('#')[0];
            //     let secondPath = window.location.href.split('#')[1];
            //     // console.log(firstPath + 'mobile/#' + secondPath);
            //     window.location.href = firstPath + 'mobile/#' + secondPath;
            // }

        },
        created() {
            this.employeeId = this.$route.params.id;
            //console.log(this.employeeId);
            //alert('created');
            //$('.loginVue').parent('.wrapper').css('margin-left', '0');

        }
    }

  </script>
